<div [ngClass]="{'blur': successModel}">
  <div class="container-fluid">

    <!-- Single white card: header row + table + pagination -->
    <div class="inv-card">

      <!-- Card header: title left · search + create button right -->
      <div class="inv-card-header">
        <h2 class="page-title">List of Invoices</h2>
        <div class="header-actions">
          <div class="search-wrapper">
            <input type="text"
                   class="search-input"
                   placeholder="Search for Invoice..."
                   [(ngModel)]="searchText"
                   (keydown)="onKeydown($event)">
            <img src="assets/img/search.svg"
                 class="search-icon"
                 (click)="onKeydown($event)">
          </div>
          <button class="btn-create" (click)="createInvoice()">
            <i class="fa fa-plus me-2"></i> Create Invoice
          </button>
        </div>
      </div>

      <!-- Scrollable table -->
      <div *ngIf="invoicelist.length > 0" class="table-responsive-wrapper">
        <table class="head-table">
          <thead>
            <tr>
              <th>
                <div class="th-content">
                  <span>Invoice Number</span>
                  <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sortingFile('invoice_no')" alt="Sort">
                </div>
              </th>
              <th>
                <div class="th-content">
                  <span>Client Name</span>
                  <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sortingFile('name')" alt="Sort">
                </div>
              </th>
              <th>
                <div class="th-content">
                  <span>Created Date</span>
                  <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sortingDateFile('created')" alt="Sort">
                </div>
              </th>
              <th>
                <div class="th-content">
                  <span>Due Date</span>
                  <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sortingDateFile('dueDate')" alt="Sort">
                </div>
              </th>
              <th>
                <div class="th-content">
                  <span>Created By</span>
                  <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sortingFile('createdby')" alt="Sort">
                </div>
              </th>
              <th>
                <div class="th-content">
                  <span>Status</span>
                  <img src="assets/img/SORT.PNG" class="sort-icon" (click)="sortingFile('status')" alt="Sort">
                </div>
              </th>
              <th class="actions-col"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let i of paginatedInvoices" class="table-row">
              <td>{{ i.invoice_no }}</td>
              <td>{{ i.name }}</td>
              <td>{{ i.created }}</td>
              <td>{{ i.dueDate }}</td>
              <td>{{ i.createdby }}</td>
              <td>
                <span class="status-badge" [ngClass]="'status-' + i.status?.toLowerCase()">
                  {{ i.status | titlecase }}
                </span>
              </td>
              <td class="action-cell">
              <button mat-icon-button class="action-btn" 
              [matMenuTriggerFor]="isRestrictedPlan() ? null : actionMenu" (click)="checkPlan($event)"
                [disabled]="i.isdisabled === true || i.document_status === 'initial' || i.document_status === 'failed'" 
                [ngClass]="{
                  'disabled': i.isdisabled === true || i.document_status === 'initial' || i.document_status === 'failed'
                }">
                <span class="action-dots">⋮</span>
              </button>

                <mat-menu #actionMenu="matMenu" class="custom-mat-menu">
                  <button mat-menu-item (click)="viewdetails(i)">
                    View Details
                  </button>

                  <button mat-menu-item (click)="editInvoice(i)">
                    Edit Invoice
                  </button>

                  <button
                    mat-menu-item
                    *ngIf="i.status === 'raised'"
                    (click)="changeStatus(i)">
                    Change Status
                  </button>

                  <div
                    class="menu-tooltip-wrapper"
                    [matTooltip]="!i.can_share ? 'Sharing documents is possible only with active client' : ''"
                    [matTooltipDisabled]="i.can_share">
                    <button
                      mat-menu-item
                      [disabled]="!i.can_share"
                      (click)="i.can_share && onSub(i)">
                      Share
                    </button>
                  </div>

                  <button mat-menu-item (click)="delete(i.id)">
                    Delete
                  </button>
                </mat-menu>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- Empty State (unchanged) -->
<!-- <div *ngIf="invoicelist && invoicelist?.length === 0 && errorMsg" class="empty-state">
  List of Invoices not available!!
</div> -->

    <div class="empty-state-container" *ngIf="invoicelist.length === 0">
    <img src="assets/img/e-invoice.png" class="empty-state-icon" alt="No entries">
    <p class="empty-state-title">No Invoices Yet!</p>
    <p class="empty-state-subtitle">There are no Invoices(s) under here.</p>
   </div>

      <!-- Pagination — inside card, below table -->
      <div class="nav-buttons" *ngIf="invoicelist.length > 0">
        <button class="prev" (click)="prev()" [disabled]="currentPage === 1">
          &lt;&lt; Prev
        </button>
        <button class="next" (click)="next()" [disabled]="currentPage === totalPages">
          Next &gt;&gt;
        </button>
      </div>

    </div><!-- /inv-card -->

  </div>
</div>

<!-- Dialog for sharing the Invoices (unchanged) -->
<!-- <div class="modal sharemodal"
     id="successModal"
     tabindex="-1"
     aria-labelledby="successModalLabel"
     aria-hidden="true"
     style="display:block;"
     *ngIf='successModel'>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <button type="button"
                class="btn-close pull-right"
                (click)="btnclose()"
                style="float: right; padding:10px;"
                aria-label="Close"></button>

        <div class="alertpara alertparatxt sharewith">
          <strong>Share With: {{invoice_data?.name}}</strong>
        </div>

        <div class="alertexted via spaceBlock">
          Via: LexiZ Lawyers(Secure)
        </div>

        <div class="container message">
          Message (optional)
          <textarea rows="4"
                    class="form-control textboxed txttxt spaceBlock"
                    [(ngModel)]="invoice_message"
                    name="invoice_message"></textarea>
        </div>

        <div class="alertbutton diaPad">
          <button class="btn btn-default btncancel btnrightitem" (click)="btnclose()">Cancel</button>
          <button class="btn btn-primary btnsave bbtn savecls" (click)="sendInvoice()">Send</button>
        </div>
      </div>
    </div>
  </div>
</div> -->


<div class="modal-overlay" *ngIf='successModel'>
  <div class="modal-card" role="dialog" aria-modal="true" aria-labelledby="modalTitle">

    <!-- Close -->
    <button class="btn-close-modal" aria-label="Close" (click)="btnclose()">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round">
        <line x1="1" y1="1" x2="13" y2="13" />
        <line x1="13" y1="1" x2="1" y2="13" />
      </svg>
    </button>

    <!-- Header -->
    <div class="modal-header">
      <h2 class="modal-title" id="modalTitle">
        Share with <span>{{invoice_data.name}}</span>
      </h2>
      <div style="margin-top: 5px;">
        <div class="via-badge">
          <span class="via-dot"></span>
          Via Lex-Z Lawyers (Secure)
        </div>
      </div>
    </div>

    <div class="divider"></div>

    <!-- Message -->
    <label class="field-label" for="invoiceMsg">
      Message <span class="optional">(optional)</span>
    </label>
    <div class="textarea-wrap">
      <textarea id="invoiceMsg" class="msg-input" name="invoice_message" oninput="this.value = this.value.replace(/[^A-Za-z0-9 ]|^ /g,'')"
        placeholder="Add a note…" [(ngModel)]="invoice_message"></textarea>
    </div>

    <!-- Actions -->
    <div class="modal-actions">
      <button class="btn btn-cancel" (click)="btnclose()">Cancel</button>
      <button class="btn btn-send" (click)="sendInvoice()">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
          stroke-linecap="round" stroke-linejoin="round">
          <line x1="22" y1="2" x2="11" y2="13" />
          <polygon points="22 2 15 22 11 13 2 9 22 2" />
        </svg>
        Send Invoice
      </button>
    </div>

  </div>
</div>

<!-- jw-modal (unchanged) -->
<jw-modal id="custom-modal-1" class="doc-view-scs">
  <div class="container">
    <div class="row">
      <div class="alertbox">
        <div
          class="close-x float-right"
          style="cursor:pointer;"
          (click)="closeModal('custom-modal-1')">
          X
        </div>

        <div class="alertpara">
          <p class="alertparatxt">Success</p>
        </div>

        <div *ngIf="isDelete" class="alertext">
          <p>{{ successMessage }}</p>
        </div>

        <div class="center">
          <button
            class="btn btn-primary okbtn"
            (click)="closeModal('custom-modal-1')">
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
</jw-modal>

<ngx-spinner size="medium" type="ball-clip-rotate"></ngx-spinner>